import { History } from 'history';
import { get } from 'lodash';
import * as React from 'react';
import { getLoginBootstrapUrl } from '../../../../config/ConfigService';
import { BROWSER_BACK, REDIRECT_URL_PARAM } from '../../../../constants/UrlParams';
import { IContent } from '../../../../login/interfaces';
import { getHashOrQueryParam } from '../../../../window/WindowUtils';
import { fireErrorAnalytics } from './errorAnalytics';
import { ErrorView } from '../../../../components/ErrorView';

const content: IContent = require('../../../../content.json');

interface ErrorPageProps {
  match?: any;
  history: History;
}

interface Error {
  heading: string;
  body: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ match, history }) => {
  React.useEffect(() => {
    fireErrorAnalytics(match.params.code);
  }, []);

  const { code: errorMatchParam } = match.params;
  const error = get(
    content.login_errors,
    errorMatchParam,
    content.login_errors.generic_error,
  ) as Error;

  const useBrowserBack = getHashOrQueryParam(BROWSER_BACK);
  const redirectUrl = getHashOrQueryParam(REDIRECT_URL_PARAM);
  let backHref = redirectUrl || getLoginBootstrapUrl();
  let onBackButtonClicked;
  if (useBrowserBack) {
    backHref = '#';
    onBackButtonClicked = history.goBack;
  }

  return (
    <ErrorView
      authenticated={errorMatchParam === 'change_password_error'}
      linkProps={{
        onLinkClicked: onBackButtonClicked,
        linkHref: backHref,
      }}
      errorMessage={error.body}
      title={error.heading}
    />
  );
};

export { ErrorPage };
